import React from 'react';
import 'twin.macro';
import { useElevesTrash } from '@teetsh/app/src/containers/UserSettings/Trash/Eleves/useElevesTrash';
import { useRestoreEleve } from '@teetsh/app/src/containers/UserSettings/Trash/Eleves/useRestoreEleve';
import { RestorableList } from '@teetsh/app/src/containers/UserSettings/Trash/components/RestorableList';
import { RestorableEleve } from '@teetsh/app/src/types/eleves';

export function ElevesRestorableList() {
  const { data = [] } = useElevesTrash();
  const restore = useRestoreEleve();

  return <RestorableList<RestorableEleve> items={data} restore={restore} />;
}
